// extracted by mini-css-extract-plugin
export default {"container":"ViewCreation_container__MqH71","formStudio":"ViewCreation_formStudio__aubOi","block":"ViewCreation_block__OuVZe","footer":"ViewCreation_footer__v7gxs"};